$brand: #ee3823;
$primary: $brand;
$dark: black;

$border-radius: 4px;
$border-radius-sm: 4px;
$border-radius-lg: 4px;

$input-border-color: rgba(0, 0, 0, 0.3);

$utilities: (
  "opacity": (
    property: opacity,
    values: (
      0: 0,
      25: 0.25,
      30: 0.3,
      40: 0.4,
      50: 0.5,
      60: 0.6,
      70: 0.7,
      75: 0.75,
      100: 1,
    ),
  ),
);

#rapidstor-v2-frontend,
.rapidstor-v2-frontend,
#contact-card-modal,
#details-modal {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

// Kept transparent so they never paint over the host page. #details-modal is
// excluded: it is its own backdrop and must be free to draw the overlay tint.
#rapidstor-v2-frontend,
.rapidstor-v2-frontend,
#contact-card-modal {
  background-color: transparent !important;
}

@import "scss/bootstrap";
@import "scss/typography";
@import "scss/elements";
@import "scss/wordpress-compatibility";

:where(#rapidstor-v2-frontend, .rapidstor-v2-frontend, #contact-card-modal, #details-modal) {
  &,
  * {
    box-sizing: border-box;
  }
}
